import React, { useRef } from 'react';
import { Button, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import './SimpleFileUpload.css';

interface SimpleFileUploadProps {
  onFileSelect: (files: FileList) => void;
  accept?: string;
  multiple?: boolean;
  disabled?: boolean;
  buttonText: string;
  icon?: any;
  intent?: Intent;
  minimal?: boolean;
}

/**
 * Simple file upload button
 * Uses hidden input with ref trigger
 */
export const SimpleFileUpload: React.FC<SimpleFileUploadProps> = ({
  onFileSelect,
  accept = '*',
  multiple = true,
  disabled = false,
  buttonText,
  icon = IconNames.PAPERCLIP,
  intent,
  minimal = false
}) => {
  const inputFileRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    if (inputFileRef.current) {
      inputFileRef.current.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    
    if (files && files.length > 0) {
      onFileSelect(files);
      event.target.value = '';
    }
  };

  return (
    <>
      <Button
        icon={icon}
        text={buttonText}
        onClick={handleButtonClick}
        disabled={disabled}
        intent={intent}
        minimal={minimal}
        small
      />
      <input
        type="file"
        ref={inputFileRef}
        onChange={handleFileChange}
        accept={accept}
        multiple={multiple}
        title="Upload file"
        aria-label="Upload file"
        className="file-input-hidden"
      />
    </>
  );
};

